/**
 * bw-cart-drawer-open.js
 * Opens the Dawn cart drawer after an AJAX add-to-cart.
 * Usage: await window.BW.openCartDrawer();
 */
(function () {
  'use strict';
  window.BW = window.BW || {};

  window.BW.openCartDrawer = async function openCartDrawer() {
    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });

      var sectionsToRequest = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'cart-notification'];
      var url = new URL(window.location.href);
      url.searchParams.set('sections', sectionsToRequest.join(','));
      var sections = await fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) { return r.json(); });

      /* Update cart count bubble (exclude ShopiSaw helper items) */
      var visibleCount = (cart.items || []).reduce(function (sum, item) {
        var role = (item.properties && item.properties._shopisaw_role) || '';
        return role.indexOf('helper') === -1 ? sum + item.quantity : sum;
      }, 0);
      var countEls = document.querySelectorAll('.cart-count-bubble span');
      countEls.forEach(function (el) { el.textContent = String(visibleCount); });

      /* Update + open drawer via Dawn's cart-drawer component */
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: sections, cart: cart });
        if (typeof drawer.open === 'function') drawer.open();
      }

      /* Update icon bubble HTML */
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var wrap = document.createElement('div');
          wrap.innerHTML = sections['cart-icon-bubble'];
          var fresh = wrap.querySelector('#cart-icon-bubble') || wrap.firstElementChild;
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    } catch (e) {
      console.warn('BW: cart drawer open failed, falling back to /cart', e);
      window.location.href = '/cart';
    }
  };
})();
